module.exports = __webpack_public_path__ + "media/icons/home-0ca55e24.svg";